import React from 'react';

import ExternalLink from '../ExternalLink/ExternalLink';

const InpostTrackingLink = ({ className, children, trackingNumber }) => {
  if (!trackingNumber) {
    return null;
  }

  return (
    <ExternalLink
      href={`https://inpost.pl/sledzenie-przesylek?number=${trackingNumber}`}
      className={className}
    >
      {children}
    </ExternalLink>
  );
};

export default InpostTrackingLink;
